
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/selection/[id]",
      function () {
        return require("private-next-pages/selection/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/selection/[id]"])
      });
    }
  